import * as React from 'react';
import * as styled from './styled';
import {IconRoundPlus} from 'icons';
import {ControlObject, SeparatorProps} from './types';
import SlideDown from 'react-slidedown';

/**
 * The separator of a blocks.
 * @param {SeparatorProps} props
 * @return {React.ReactElement<SeparatorProps>}
 * @constructor
 */
export default function Separator<T extends string>(
    props: SeparatorProps<T>,
): React.ReactElement<SeparatorProps<T>> {
  const [
    controlsVisibility, setControlsVisibility,
  ] = React.useState<boolean>(
    props.defaultControlsVisibility || false,
  );

  /**
   * Toggle the expanded state.
   * @return {void}
   */
  function toggleContent(): void {
    setControlsVisibility(!controlsVisibility);
  }

  /**
   * Render header.
   * @return {JSX.Element}
   */
  function renderHeader(): JSX.Element {
    /**
     * The click event handler.
     * @return {void}
     */
    function handleClick(): void {
      toggleContent();
    }

    return (
      <styled.Header type="button" onClick={handleClick}>
        <styled.IconContainer controlsVisibility={controlsVisibility}>
          <IconRoundPlus />
        </styled.IconContainer>
        Добавить блок
      </styled.Header>
    );
  }

  /**
   * Render controls.
   * @return {JSX.Element}
   */
  function renderControls(): JSX.Element {
    /**
     * Render control.
     * @param {ControlObject<T>} control
     * @param {number} index
     * @return {JSX.Element}
     */
    function renderControl(
        control: ControlObject<T>,
        index: number,
    ): JSX.Element {
      /**
       * The click event handler.
       */
      function handleClick(): void {
        props.onControlClick && (
          props.onControlClick(
            control
          )
        )
      }

      return (
        <styled.Control type="button" onClick={handleClick}>
          {control.label}
        </styled.Control>
      );
    }

    return (
      <SlideDown closed={!controlsVisibility}>
        <styled.Controls>
          {props.controls.map((control, index) => (
            renderControl(control, index)
          ))}
        </styled.Controls>
      </SlideDown>
    );
  }

  return (
    <styled.Wrapper>
      {renderHeader()}
      {renderControls()}
    </styled.Wrapper>
  );
}
